import { Skeleton, Typography } from "@mui/material";
import React from "react";
import LogCardMin from "./LogCardMin";
import { useSelector } from "react-redux";
import Loading from "../../../../../Loading/Loading";
import DialogLogs from "./Dialog";

const Logs = ({ logs, isLoading, isLoadingSave, onRemove, top = 250 }) => {
  const currentCurriculum = useSelector(
    (state) => state?.assessment?.currentCurriculum || {}
  );
  const lcs = useSelector((state) => state?.class?.unitOfLearning?.lcs || []);
  const logsData = logs.slice(0, 4);
  const [dialog, setDialog] = React.useState(false);
  return (
    <>
      {isLoadingSave && (
        <div
          className="bg-loading bottom-0 absolute z-21 overflow-auto border-t border-muted"
          style={{ top: `calc(${top}px + 2rem)`, width: "calc(200px - 0.5rem)" }}
        >
          <Loading />
        </div>
      )}
      <div
        className={[
          "bg-background bottom-0 absolute z-20 overflow-auto border-t border-muted",
        ]}
        style={{ top: `calc(${top}px + 2rem)`, width: "calc(200px - 0.5rem)" }}
      >
        <div className="pt-4 pb-2 pl-1 pr-2 flex flex-col gap-2">
          {isLoading ? (
            Array.from({ length: 3 }).map((_, i) => (
              <Skeleton
                variant="rectangular"
                className="rounded"
                key={`log-loading-${i}`}
                height={100}
              />
            ))
          ) : logs?.length > 0 ? (
            logsData.map((log, i) => {
              const lc = lcs.find((lc) => String(lc._id) === String(log.lcId));
              return (
                <LogCardMin
                  id={`log-${log._id}-${i}-${log.lcId}`}
                  key={`log-${log._id}-${i}-${log.lcId}`}
                  log={log}
                  lc={lc}
                  className="bg-clickeabled  cursor-pointer"
                  currentCurriculum={currentCurriculum}
                  onRemove={i === 0 && log.ulId ? onRemove : undefined}
                  onClick={() => setDialog(log._id)}
                />
              );
            })
          ) : (
            <Typography className="text-muted-foreground opacity-50 text-center">
              You don't have any log yet
            </Typography>
          )}
        </div>
        <div>
          {!isLoading && logsData.length < logs.length && (
            <Typography
              className="text-muted-foreground opacity-50 text-center cursor-pointer"
              onClick={() => {
                setDialog(logs[0]?._id);
              }}
            >
              View all logs
            </Typography>
          )}
        </div>
      </div>
      { dialog && (
        <DialogLogs
          currentCurriculum={currentCurriculum}
          lcs={lcs}
          show={!!dialog}
          logId={dialog}
          onClose={() => setDialog(false)}
          logs={logs}
        />
      )}
    </>
  );
};

export default Logs;
